var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.132 5.096a3.832 3.832 0 0 1 3.843 3.843 3.832 3.832 0 0 1-3.843 3.843 3.832 3.832 0 0 1-3.843-3.845 3.833 3.833 0 0 1 3.843-3.841zm-6.3 7.147a2.507 2.507 0 0 0-3.969.182L3.17 20.567l-.047.074-.04.08a1.124 1.124 0 0 0 .364 1.408 1.121 1.121 0 0 0 1.562-.276l5.693-8.143.027-.035.032-.031a.267.267 0 0 1 .374.067l2.9 4.163.06.082.072.087a1.915 1.915 0 0 0 2.999-.157l.297-.42.029-.037.032-.03a.267.267 0 0 1 .37.067l3.092 4.39.053.069.064.068c.396.393.998.448 1.445.134a1.122 1.122 0 0 0 .272-1.563l-3.091-4.39-.062-.084-.074-.09-.079-.09a2.508 2.508 0 0 0-3.881.26l-.026.036-2.632-3.777-.062-.085-.08-.101zm4.601-3.304a1.689 1.689 0 0 1 1.699-1.7c.947 0 1.699.753 1.699 1.7s-.752 1.699-1.7 1.699a1.688 1.688 0 0 1-1.698-1.7z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscape);
export default __webpack_public_path__ + "static/media/landscape.c7bd2a0b9329c244e8949dfec910ff2a.svg";
export { ForwardRef as ReactComponent };